import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableComponent } from './data-table/data-table.component';
import { ApiRoutes } from './api-routes';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {
  MatDialogModule, MatTabsModule, MatProgressBarModule, MatTableModule, MatDatepickerModule, MatNativeDateModule,
  MatButtonModule, MatCheckboxModule, MatGridListModule, MatCardModule, MatMenuModule, MatIconModule,
  MatToolbarModule, MatSidenavModule, MatListModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatPaginatorModule, MatSortModule, MatProgressSpinnerModule,
  MatBadgeModule,
  MatRadioModule,
  MatChipsModule,
  MatAutocompleteModule,
  MatPaginatorIntl,
  MatExpansionModule
} from '@angular/material';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { AddressControlComponent } from './address-control/address-control.component';
import { InegiService } from './address-control/inegi.service';
import { MapModule } from '../components/map/map.module';
import {getDutchPaginatorIntl} from './data-table/data-table.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DateUtcToLocalService } from '../core/services/date-utc-to-local.service';

@NgModule({
  declarations: [
    DataTableComponent,
    ConfirmDialogComponent,
    AddressControlComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule, MatTabsModule, MatProgressBarModule, MatTableModule, MatInputModule, MatDatepickerModule, MatNativeDateModule,
    MatFormFieldModule, MatButtonModule, MatCheckboxModule, MatGridListModule, MatCardModule,
    MatMenuModule, MatIconModule, MatToolbarModule, MatSidenavModule, MatListModule, MatProgressSpinnerModule, MatSelectModule, MatPaginatorModule, MatSortModule,
    MatBadgeModule, MatRadioModule, MatChipsModule, MatAutocompleteModule,
    MapModule, MatExpansionModule, NgxMatSelectSearchModule
  ],
  providers: [
    ApiRoutes,
    InegiService,
    { provide: MatPaginatorIntl, useValue: getDutchPaginatorIntl()},
    DateUtcToLocalService
  ],
  exports: [
    DataTableComponent,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule, MatTabsModule, MatProgressBarModule, MatTableModule, MatInputModule, MatDatepickerModule, MatNativeDateModule,
    MatFormFieldModule, MatButtonModule, MatCheckboxModule, MatGridListModule, MatCardModule,
    MatMenuModule, MatIconModule, MatToolbarModule, MatSidenavModule, MatListModule, MatProgressSpinnerModule, MatSelectModule, MatPaginatorModule, MatSortModule,
    MatBadgeModule, MatRadioModule, MatChipsModule, MatAutocompleteModule,
    AddressControlComponent, NgxMatSelectSearchModule
  ],
})
export class SharedModule { }
